import React from 'react';

import { Text } from '~/components/blocks';
import { ReceptionUberDeliveryFragment } from '~/graphql/generated/graphql';
import { fontSizes } from '~/styles/theme';

type Props = {
  uberDelivery: ReceptionUberDeliveryFragment | null | undefined;
};

export const ReturnDeliveryInfo = (props: Props) => {
  const { uberDelivery } = props;

  if (uberDelivery?.status === 'canceled') {
    if (!uberDelivery.returnPinCode) {
      return (
        <Text size="s" color="pink" fontWeight="bold" whiteSpace="nowrap">
          暗証番号：取得失敗
        </Text>
      );
    }

    return (
      <Text size="s" color="pink" fontWeight="bold" whiteSpace="nowrap">
        暗証番号：
        <Text as="span" size="l" color="pink" fontWeight="bold" lineHeight={fontSizes.s}>
          {uberDelivery.returnPinCode}
        </Text>
      </Text>
    );
  }

  if (uberDelivery?.status === 'return_delivered') {
    return (
      <Text size="s" color="grey01" whiteSpace="nowrap">
        配達キャンセル
      </Text>
    );
  }

  return null;
};
